import React, { useContext } from 'react';
import { SectionalAlertErrorIcon } from '../../../assets/icons';
import { Button } from '../../baseComponents';
import './ErrorCatch.css';
import { triggerAppError } from '../../Routing/Redirection';
import { pathContext } from '../../../contexts/contexts';

export const ErrorCatch = () => {
  const { setUrl } = useContext(pathContext);

  const handleEnterDown = (e: any) => {
    handleSelect();
  };

  const handleSelect = () => {
    triggerAppError(false);
    setUrl('/sign-in');
  };

  return (
    <div className="card mx-auto" data-testid="error-catch-testid">
      <div id="sectional-alert-message" className={`flex flex-row w-full  p-4 items-start error-container `}>
        <div data-testid="error-icon" aria-label="error-icon" className={`error-icon pt-1 pr-2 items-top`}>
          <SectionalAlertErrorIcon />
        </div>
        <div className="error-body break-words items-center grow text-xl" data-testid="alert-message">
          We're sorry, something went wrong
        </div>
      </div>
      <br />
      <div className="pt-2 font-medium text-md text-dhs_font_gray">
        <p>The page you are looking for may not exist or is temporarily unavailable.</p>
      </div>
      <br />
      <div className="pt-2 font-small text-sm text-dhs_font_gray">
        <p>
          To help you find what you are looking for, try: {/*SonarQube no space required*/}
          <a
            className="text-dhs_light_blue hover:text-dhs_focus_light_blue hover:underline focus:ring-1 focus:ring-dhs_focus_blue focus:underline mt-2 mb-5"
            href="https://www.uscis.gov/"
            rel="noreferrer"
            target="_blank"
            title="uscis gov"
          >
            uscis.gov
          </a>
        </p>
      </div>

      <div className="w-full mt-8 mb-6 flex items-center justify-between sm:flex-row flex-col flex-wrap">
        <Button
          id="sign-in-btn"
          text="Return to Sign in"
          className={`w-full md:w-5/12 text-md`}
          onMouseDown={handleSelect}
          onKeyDown={handleEnterDown}
        />
      </div>
    </div>
  );
};
